import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon, DropletsIcon, LeafIcon } from 'lucide-react';
const prioriza = [{
  text: 'Verduras (la mitad del plato): hojas verdes, brócoli, coliflor, pimientos'
}, {
  text: 'Frutas: frutos rojos, manzana, cítricos'
}, {
  text: 'Proteínas: pescado (salmón/sardina), pollo/pavo, huevos, legumbres, tofu'
}, {
  text: 'Grasas buenas: aceite de oliva, aguacate, nueces/almendras, chía/linaza'
}, {
  text: 'Carbohidratos integrales: avena, quinoa, arroz integral, camote'
}, {
  text: 'Especias antiinflamatorias: cúrcuma, jengibre, canela, ajo'
}];
const reduce = [{
  text: 'Bebidas azucaradas, dulces, pan/pasta blancos'
}, {
  text: 'Frituras, embutidos, comida rápida, snacks ultraprocesados'
}, {
  text: 'Alcohol (ideal: 0 por 14 días)'
}, {
  text: 'Exceso de harinas/refinados'
}];
export function RulesSection() {
  return <section id="rules" className="py-24 px-4 sm:px-6 lg:px-8 bg-wellness-cream relative" data-id="element-131">
      <div className="max-w-6xl mx-auto" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-133">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-wellness-sage text-wellness-primary mb-6" data-id="element-134">
            <LeafIcon className="w-8 h-8" data-id="element-135" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-136">
            Reglas Simples
          </h2>
          <p className="text-xl text-wellness-text/80 max-w-2xl mx-auto" data-id="element-137">
            Para los próximos 14 días, enfócate en nutrir tu cuerpo y darle un
            descanso de los alimentos inflamatorios.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-blue-50/80 border border-blue-100 rounded-2xl p-6 mb-12 flex items-center justify-center gap-4 max-w-3xl mx-auto shadow-organic-sm" data-id="element-138">
          <div className="bg-blue-100 p-3 rounded-full text-blue-600" data-id="element-139">
            <DropletsIcon className="w-6 h-6" data-id="element-140" />
          </div>
          <div data-id="element-141">
            <h3 className="font-semibold text-blue-900 text-lg" data-id="element-142">Hidratación</h3>
            <p className="text-blue-800/80" data-id="element-143">
              1.5–2.5 L/día (ajusta por clima/actividad)
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-144">
          {/* Prioriza Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-wellness-sage/30 rounded-[2rem] p-8 sm:p-10 border border-wellness-sage/50 relative overflow-hidden" data-id="element-145">
            <div className="absolute top-0 right-0 w-32 h-32 bg-wellness-soft/10 rounded-full blur-2xl -mr-10 -mt-10" data-id="element-146"></div>

            <h3 className="text-3xl font-serif font-semibold text-wellness-primary mb-8 flex items-center gap-3" data-id="element-147">
              <span className="bg-wellness-soft/20 text-wellness-medium p-2 rounded-xl" data-id="element-148">
                <CheckCircleIcon className="w-6 h-6" data-id="element-149" />
              </span>
              Prioriza
            </h3>

            <ul className="space-y-6 relative z-10" data-id="element-150">
              {prioriza.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2 + index * 0.1
            }} className="flex items-start gap-4" data-id="element-151">
                  <CheckCircleIcon className="w-6 h-6 text-wellness-soft shrink-0 mt-0.5" data-id="element-152" />
                  <span className="text-wellness-text/90 text-lg leading-relaxed" data-id="element-153">
                    {item.text}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>

          {/* Reduce Column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-orange-50/50 rounded-[2rem] p-8 sm:p-10 border border-orange-100 relative overflow-hidden" data-id="element-154">
            <div className="absolute top-0 right-0 w-32 h-32 bg-wellness-accent/10 rounded-full blur-2xl -mr-10 -mt-10" data-id="element-155"></div>

            <h3 className="text-3xl font-serif font-semibold text-orange-900 mb-8 flex items-center gap-3" data-id="element-156">
              <span className="bg-orange-100 text-wellness-accent p-2 rounded-xl" data-id="element-157">
                <XCircleIcon className="w-6 h-6" data-id="element-158" />
              </span>
              Reduce o Evita
            </h3>

            <ul className="space-y-6 relative z-10" data-id="element-159">
              {reduce.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3 + index * 0.1
            }} className="flex items-start gap-4" data-id="element-160">
                  <XCircleIcon className="w-6 h-6 text-wellness-accent/80 shrink-0 mt-0.5" data-id="element-161" />
                  <span className="text-wellness-text/90 text-lg leading-relaxed" data-id="element-162">
                    {item.text}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}